module.exports = __webpack_public_path__ + "img/img-fd55e1.png";